import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {

	btnContainer: {
		textAlign: "center"
	},

	icon: {
		height : "2.4rem",
		width  : "2.4rem"
	},

	iconContainer: {
		padding         : "0.75rem",
		backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite20 : theme.other.paletteNew.darkModeDarkGrey20,
		display         : "flex",
		width           : "min-content",
		borderRadius    : "100%",
		margin          : "auto",
		marginBottom    : "0.8rem",

		"&.active": {
			backgroundColor: theme.other.paletteNew.darkModeDarkBlue50
		}
	},

	iconText: {
		fontSize: "1.2rem"
	}
} ) );
